/* eslint-disable jsx-a11y/label-has-for */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import CSVReader from 'react-csv-reader';
import { Container } from './style';

const BoxUpload = ({
  originalName,
  handleSelectFile,
  anoSelecionado,
  isResend,
  setErrorFile,
  setMessageErrorFile,
}) => {
  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header => header.toLowerCase().replace(/\W/g, '_'),
  };

  const formataAnoPeriodo = function (anoPeriodo = '') {
    if(anoPeriodo.length == 2)
      return Number.parseInt('20' + anoPeriodo);

    if(anoPeriodo.length == 4)
      return Number.parseInt(anoPeriodo);

    return false;
  }

  const handleCsv = useCallback(
    (data, fileInfo, anoSelecionado) => {
      const csvFile = document.getElementById('fileUploadCSV');
      const regex = /^([a-zA-Z0-9\s_\\.\-:])+(.csv)$/;
      const fileSize = Object.keys(data[0]).length;
      const periodo = Object.values(data[0])[1];
      

      if (!regex.test(fileInfo.name.toLowerCase())) {
        setErrorFile(true);
        setMessageErrorFile('Selecione um arquivo válido.');
        return;
      }

     let anoPeriodo = formataAnoPeriodo(periodo.split("/")[1]);

     if(!anoPeriodo) {
        setMessageErrorFile('Ano do periodo informado no arquivo invalido');
        setErrorFile(true);
        return;
     }

      if(anoPeriodo <= 2023 && fileSize == 86){
        setErrorFile(true);
        setMessageErrorFile('Utilize a planilha no formato antigo.');
        return;
      }

      if(anoPeriodo >= 2024 && fileSize == 85){
        setErrorFile(true);
        setMessageErrorFile('Utilize a planilha no formato novo.');
        return;
      }
      
      if (handleSelectFile && csvFile) {
        handleSelectFile({ file: csvFile.files[0], data });
      }
    },
    [handleSelectFile, setErrorFile]
  );

  return (
    <Container id="BoxUpload">
      <form id="fileUploadForm">
        <label htmlFor="fileUpload">
          <CSVReader
            inputId="fileUploadCSV"
            cssClass="react-csv-input"
            label="Selecione o arquivo"
            onFileLoaded={handleCsv}
            parserOptions={papaparseOptions}
            accept=".csv,text/csv"
          />

          <span className="fileUploadText">
            {originalName != null ? (
              <>
                Arquivo selecionado: <br /> <br />
                {originalName}
                <br />
              </>
            ) : (
              <>
                {isResend ? (
                  <span>
                    Clique aqui para <br /> enviar outro arquivo.
                  </span>
                ) : (
                  <span>
                    Busque o arquivo para <br /> fazer upload.
                  </span>
                )}
              </>
            )}
          </span>
        </label>
      </form>
    </Container>
  );
};

BoxUpload.propTypes = {
  originalName: PropTypes.string,
  handleSelectFile: PropTypes.func,
  anoSelecionado: PropTypes.string,
  setErrorFile: PropTypes.func,
  isResend: PropTypes.bool,
};

BoxUpload.defaultProps = {
  originalName: null,
  handleSelectFile: null,
  anoSelecionado: null,
  setErrorFile: null,
  isResend: false,
};

export default BoxUpload;
